import React from "react";
/* CacheBuster component */
import packageJson from "../package.json";
global.appVersion = packageJson.version;

const semverGreaterThan = (versionA, versionB) => {
  // code from above snippet goes here
  return versionA !== versionB ? true : false;
};

export default class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log("Clearing cache and hard reloading...");
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches
            .keys()
            .then(async function (names) {
              await Promise.all(names.map(name => caches.delete(name)));
            })
            .then(() => {
              window.location.reload(true);
            });
        }
        // delete browser cache and hard reload
      }
    };
  }

  componentDidMount() {
    fetch("/meta.json", { cache: "no-cache" })
      .then(response => response.json())
      .then(meta => {
        const latestVersion = meta.version;
        const currentVersion = global.appVersion;

        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion
        );
        if (shouldForceRefresh) {
          console.log(
            `We have a new version - ${latestVersion}. Should force refresh - current vers: ${currentVersion}`
          );
          this.setState({ loading: false, isLatestVersion: false });
        } else {
          console.log(
            `You already have the latest version - ${latestVersion}. No cache refresh needed. current vers: ${currentVersion}`
          );
          this.setState({ loading: false, isLatestVersion: true });
        }
      });
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload
    });
  }
}
